import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Button } from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

import useLocales from '../../hooks/useLocales';
import { PAGE_SIZE } from '../../@types/documents/constants/InitialValues';

// ----------------------------------------------------------------

const GridToolbarCleanAll: React.FC = () => {
  const { t, currentLang } = useLocales();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClick = () => {
    const models = ['filterModel', 'sortModel', 'paginationModel', 'formTemplateId'];

    for (let i = 0; i < models.length; i++) {
      searchParams.delete(models[i]);
    }

    const savedPageSize = localStorage.getItem('pageSize');
    const defaultPaginationModel = {
      pageSize: savedPageSize ? Number(savedPageSize) : PAGE_SIZE,
      page: 0,
    };

    searchParams.set('paginationModel', JSON.stringify(defaultPaginationModel));

    setSearchParams(searchParams);
  };

  return (
    <Button
      id="clean-all-button"
      size="small"
      startIcon={<FilterAltOffIcon />}
      onClick={handleClick}
    >
      {t('documents.analytics.buttons.cleanAll')}
    </Button>
  );
};

export default GridToolbarCleanAll;
